<template>
  <WdsProgressBar
    :label="label"
    :progress="spentPercentage"
    :progress-tooltip-text="formattedSpent"
    :projected="allocatedPercentage"
    :projected-tooltip-text="formattedAllocated"
  >
    <template #progressInfo>
      <WdsStack v-if="!hideProgress">
        <WdsText>{{ formattedSpentPercentage }}</WdsText>
        &nbsp;
        <WdsText tertiary>/ {{ formattedBudget }}</WdsText>
      </WdsStack>
    </template>
  </WdsProgressBar>
</template>

<script setup>
import { computed } from 'vue'
import { WdsProgressBar, WdsStack, WdsText } from '@worksome/wds-components'
import { toFormattedAmountByLocale } from '@/utils/currency'

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  spent: {
    type: Number,
    default: null,
  },
  budget: {
    type: Number,
    default: null,
  },
  allocated: {
    type: Number,
    default: null,
  },
  currency: {
    type: String,
    default: null,
  },
  hideProgress: {
    type: Boolean,
    default: false,
  },
})

const formatAmount = (val) =>
  `${props.currency ?? ''} ${
    val ? toFormattedAmountByLocale(val.toFixed(2), window.currentLocale, true) : '-'
  }`

const spentPercentage = computed(() => ((props.spent ?? 0) / props.budget) * 100)

const allocatedPercentage = computed(() => ((props.allocated ?? 0) / props.budget) * 100)

const formattedSpentPercentage = computed(() =>
  props.budget === null || props.budget === 0 ? '-' : `${spentPercentage.value.toFixed(2)}%`,
)

const formattedSpent = computed(() => formatAmount(props.spent))

const formattedAllocated = computed(() => formatAmount(props.allocated))

const formattedBudget = computed(() => formatAmount(props.budget))
</script>

<style lang="scss" scoped>
:deep(.wds-tooltip) {
  z-index: 100;
}

.wds-stack {
  display: inline-flex;
}

.progress-bar {
  box-shadow: none;
}
</style>
